// The builder pane hands the action cards their wheel target here, so XoeChat's thread chain carries no wheel props.
// Outside the provider (floating widget, /xoe page) the hook answers null and wheel cards render without a Confirm.
import { createContext, useContext } from "react";
import type { WheelActionTarget } from "../../../types/xoe/XoeUiTypes";

const WheelActionTargetContext = createContext<WheelActionTarget | null>(null);

export const WheelActionTargetProvider = WheelActionTargetContext.Provider;

export const useWheelActionTarget = (): WheelActionTarget | null => useContext(WheelActionTargetContext);
